import {PremiumPaidUp as PremiumPaidUpLetter} from 'Agent/Policies/api/apiTypes';
import React from 'react';
import CardField from 'Shared/components/CardField';
import {toFormattedDateAsUTC} from 'Shared/utilities/DateFormatter';

type PremiumPaidUpLetterProps = {
  premiumPaidUpLetter: PremiumPaidUpLetter;
};

const PremiumPaidUp = (props: PremiumPaidUpLetterProps) => {
  return (
    <>
      <CardField name={'Insured Name'} value={props.premiumPaidUpLetter.insuredName} />
      <CardField name={'Owner Name'} value={props.premiumPaidUpLetter.ownerName} />
      <CardField name={'Owner Address'} value={props.premiumPaidUpLetter.ownerAddress!.fullAddress} />
      <CardField name={'Policy Number'} value={props.premiumPaidUpLetter.policyNumber} />
      <CardField name={'Date'} value={toFormattedDateAsUTC(props.premiumPaidUpLetter.date)} />
      <CardField name={'Agent Number'} value={props.premiumPaidUpLetter.agentNumber} />
    </>
  );
};

export default PremiumPaidUp;
